import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagInput } from './tag-input';
import { ProjectService } from '@data/services/project.service';

@Component({

    selector: 'syn-project-tag-input',
    templateUrl: 'tag-input.html',
    styleUrls: ['tag-input.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ProjectTagInputComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ProjectTagInputComponent), multi: true }
    ]
})
export class ProjectTagInputComponent extends TagInput {
    constructor(projectService: ProjectService) {
        super(projectService);
    }
}
